import PatchController from '../PatchController';

export default class DefaultController extends PatchController {
	public handle() {
		this.redirect(this.routes.dashboard.indexRoute.href);
	}
}
